import React, { useState, useEffect } from 'react';
import PlayerAnalysis from './Player';
import TeamAnalysis from './Team';
import HeadtoHead from './HeadtoHead';
import BottomNav from './Bottomnavi';
import AboutModal from './aboutmodals'; 

function App() {
  const [playerData, setPlayerData] = useState([]);
  const [teams, setTeams] = useState([]);
  const [currentPage, setCurrentPage] = useState('player');

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log('Fetching CSV data...');
        
        // Fetch player stats
        const statsResponse = await fetch('./womens_stats_2024_progress_round1_noteam.csv');
        if (!statsResponse.ok) throw new Error('Network response was not ok');
        const statsCsv = await statsResponse.text();
        
        // Fetch player dictionary
        const dictResponse = await fetch('./dictionary.csv');
        if (!dictResponse.ok) throw new Error('Network response was not ok');
        const dictCsv = await dictResponse.text();
        
        // Parse CSVs
        const parseCsv = (csv) => {
          const lines = csv.split('\n');
          const headers = lines[0].split(',').map(header => header.trim());
          return lines.slice(1).map(line => {
            const values = line.split(',').map(value => value.trim());
            return headers.reduce((obj, header, index) => {
              obj[header] = values[index];
              return obj;
            }, {});
          });
        };

        const statsData = parseCsv(statsCsv);
        const dictData = parseCsv(dictCsv);

        // Merge data based on Player and Player Name
        const mergedData = statsData.map(stat => {
          const playerDict = dictData.find(dict => dict['Player Name'] === stat.Player);
          return { ...stat, ...playerDict };
        });

        const uniqueTeams = [...new Set(dictData.map(dict => dict['Team']))].sort();
        setTeams(uniqueTeams);
        setPlayerData(mergedData);
      } catch (error) {
        console.error('Error fetching the CSV file:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white p-6">
      <AboutModal />
      <div className="mb-12 relative">
      <h1 className="text-7xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-emerald-400 to-blue-500 pb-3">
          Insight50
        </h1>
        <p className="text-gray-400 text-lg tracking-wider">SANFL Women's Performance Analysis</p>
        <div className="absolute -top-10 -left-10 w-32 h-32 bg-blue-500 rounded-full mix-blend-multiply filter blur-xl opacity-25 animate-blob"></div>
        <div className="absolute -top-10 -right-10 w-32 h-32 bg-emerald-500 rounded-full mix-blend-multiply filter blur-xl opacity-25 animate-blob animation-delay-2000"></div>
      </div>

      <BottomNav currentPage={currentPage} setCurrentPage={setCurrentPage} />

      {currentPage === 'player' ? (
        <PlayerAnalysis playerData={playerData} teams={teams} />
      ) : currentPage === 'team' ? (
        <TeamAnalysis playerData={playerData} teams={teams} />
      ) : currentPage === 'headtohead' ? (
        <HeadtoHead playerData={playerData} teams={teams} />
      ) : null}
    </div>
  );
}

export default App;